import styled from 'styled-components';

export const SubHeader = styled.h5`
  margin-top: 1rem;
`;

export const CodeContainer = styled.pre`
  color: ${({ theme }) => theme.freecode.color};
`;
